/**
 * Global Header functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new Global Header instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
  }
}



// WEBPACK FOOTER //
// ./components/global-header/index.js